/* eslint-disable */
// Based on https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure

class Map {
    constructor() {
        this.instances = $('[data-progressive-enhancement="off"][data-progressive-enhancement-type="map"]');

        this.mapStatus = null;

        this.markers = [];
    }

    init(helpers) {
        const self = this;

        this.helpers = helpers;

        self.enhanceAll(self);
    }

    addPlacesLayer(placesLayer, service, results, status, map, infoWindow, instance, self) {
        let i,
            toggleButton = self.helpers.createButton(''),
            span = document.createElement('span'),
            pseudoContentSpan = document.createElement('span'),
            placesType = placesLayer.dataset.placesTypes,
            placesIcon = placesLayer.dataset.placesIcon,
            markers = [];

        instance.parentElement.querySelector('section').appendChild(toggleButton);

        toggleButton.setAttribute('aria-pressed', 'false');

        toggleButton.appendChild(pseudoContentSpan);

        pseudoContentSpan.classList.add('pseudo-content');
        pseudoContentSpan.setAttribute('aria-hidden', 'true');
        pseudoContentSpan.dataset.pseudoContent = '✔️';
        
        placesLayer.removeChild(placesLayer.querySelector('.visually-hidden'));
        
        while(placesLayer.childNodes[0]) {
            toggleButton.appendChild(placesLayer.removeChild(placesLayer.childNodes[0]));
        }
        
        toggleButton.dataset.placesLayer = placesType;
        
        toggleButton.dataset.placesTypeFriendlyName = placesLayer.dataset.placesTypeFriendlyName;
        
        toggleButton.appendChild(span);
        
        span.className = 'visually-hidden button__state';
        
        span.setAttribute('aria-hidden', 'true');
        
        if (google.maps.places.PlacesServiceStatus.OK !== status) {
            toggleButton.disabled = true;

            return;
        }

        for (i = 0; i < results.length; i++) {
            markers.push(self.createPlacesMarker(i + 1, placesLayer, service, results[i], map, infoWindow));
        }

        toggleButton.addEventListener('click', e => {
            let toggleButton = e.currentTarget,
                toggleButtonStateSpan = toggleButton.querySelector('.button__state'),
                placesLayer = toggleButton.dataset.placesLayer,
                pressed = toggleButton.getAttribute('aria-pressed'),
                searchParams = new URLSearchParams(window.location.search),
                places;

            if('true' === pressed) {
                while(toggleButtonStateSpan.childNodes[0]) {
                    toggleButtonStateSpan.removeChild(toggleButtonStateSpan.childNodes[0]);
                }
                
                self.hidePlacesLayer(placesLayer, map, instance, self);

                toggleButton.setAttribute('aria-pressed', 'false');

                wp.a11y.speak(wp.i18n.sprintf(i18n.Map.markerTypeRemovedFromMap, toggleButton.dataset.placesTypeFriendlyName));
            } else {
                toggleButtonStateSpan.appendChild(document.createTextNode(' (' + i18n.Map.pressed + ')'));

                self.showPlacesLayer(placesLayer, map, instance, self);

                toggleButton.setAttribute('aria-pressed', 'true');

                wp.a11y.speak(wp.i18n.sprintf(i18n.Map.markerTypeAddedToMap, toggleButton.dataset.placesTypeFriendlyName));
            }
        });

        return markers;
    }

    addPlacesLayers(placesLayers, map, instance, self) {
        let section = document.createElement('section'),
            heading = document.createElement('h3'),
            anchor = document.createElement('a'),
            anchorText = document.createTextNode(i18n.Map.seeSurroundingAmenities);

        heading.classList.add('title-5');

        instance.parentElement.appendChild(section);
        section.id = instance.id + '__' + self.helpers.sanitizeTitle(anchorText.textContent);
        section.setAttribute('aria-labelledby', section.id + '__heading');
        section.className = 'institution__location__see-surrounding-amenities';
        section.appendChild(heading);
        heading.id = section.id + '__heading';
        heading.appendChild(anchor);

        anchor.href = '#institution__location__see-surrounding-amenities';

        anchor.appendChild(anchorText);

        for(let placesLayer of placesLayers) {
            let infoWindow = new google.maps.InfoWindow(),
                service = new google.maps.places.PlacesService(map);

            service.nearbySearch(
                {
                    location: map.getCenter(),
                    radius: 2000,
                    type: [placesLayer.dataset.placesTypes],
                    fields: ['formatted_address']
                },
                (results, status) => {
                    self.markers[placesLayer.dataset.placesTypes] = self.addPlacesLayer(placesLayer, service, results, status, map, infoWindow, instance, self);
                }
            );
        }
    }

    createPlacesMarker(i, placesLayer, service, place, map, infoWindow) {
        var marker = new google.maps.Marker({
            map: map,
            position: place.geometry.location,
            visible: false,
            optimized: false,
            title: placesLayer.dataset.placesTypeFriendlyName + ' ' + i + ': ' + place.name 
        });

        if(placesLayer.dataset.placesIcon) {
            marker.setIcon(placesLayer.dataset.placesIcon);
        }
        
        google.maps.event.addListener(marker, 'click', function() {
            let address = '';

            if(place.adr_address) {
                address = place.adr_address;
            }

            // infoWindow.setContent(placesLayer.dataset.placesTypeFriendlyName + ' ' + i + ': ' + place.name + '<br>' + address);
            // infoWindow.open(map, this);
            var request = {
                reference: place.reference
            };

            service.getDetails(request, function(details, status) {
                let infowindowContent = '<h2>' + '<span class="visually-hidden">' + placesLayer.dataset.placesTypeFriendlyName + ' ' + i + ': </span>' + details.name + '</h2>';

                if(details.photo) {
                    infowindowContent += '<p>' + details.photo + '</p>';
                }
                
                infowindowContent += '<dl>';

                infowindowContent += '<dt class="visually-hidden">' + i18n.Map.address + '</dt>';
                
                if(details.formatted_address) {
                    infowindowContent += '<dd>' + details.formatted_address + '</dd>';

                } else {
                    infowindowContent += '<dd class="visually-hidden">' + i18n.Map.notAvailable + '</dd>';
                }

                infowindowContent += '<dt class="visually-hidden">' + i18n.Map.website + '</dt>';

                if(details.website) {
                    infowindowContent += '<dd><a href="' + details.website + '" rel="noopener nofollow" target="_blank" class="button-primary">' + i18n.Map.visitWebsite + '<span class="visually-hidden"> ' + i18n.Map.opensInANewTab + '</span></a></dd>';
                } else {
                    infowindowContent += '<dd class="visually-hidden">' + i18n.Map.notAvailable + '</dd>';
                }

              infoWindow.setContent(infowindowContent);

              infoWindow.open({
                shouldFocus: true,
                anchor: marker,
              });
            });
        });

        return marker;
    }

    /**
     * Enhance
     *
     * Adds JS functionality (progressive enhancements) to an instance of
     * the Tabbed Interface component. See also: Revert
     *
     * @param {obj} instance The HTMLElement Object to be enhanced
     * @param {obj} self This class object
     */
     enhance(instance, self) {
         let i,
             bounds = new google.maps.LatLngBounds(),
             map,
             markers = instance.querySelectorAll('.js-map-marker');

            // Commenting out to remove filter logic
            // placesLayers = instance.querySelectorAll('.js-map-places-layer'),
            // options;

        while(instance.children[0]) {
            instance.removeChild(instance.children[0]);
        }

        //  Adding the marker at the institute's location
        map = new google.maps.Map(instance, {
            zoom: parseInt(instance.dataset.zoom) || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapId: '7c23a5515e58b5ec',
        });

        map.markers = [];

        //  Currently there should only be one marker
        for(i = 0; i < markers.length; i++) {
            let data = markers[i].dataset,
                marker = new google.maps.Marker({
                    position : {
                        lat: parseFloat(data.markerLat),
                        lng: parseFloat(data.markerLng),
                    },
                    map: map
                });

            map.markers.push(marker);

            bounds.extend({
                lat: map.markers[i].position.lat(),
                lng: map.markers[i].position.lng()
            });
        };

        if(1 === map.markers.length){
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }

        instance.style.maxWidth = '100%';
        instance.style.height = '40vw';

         /**
        * Temporarly removing map filtering to reduce API costs
        * START:
        */
        // if(placesLayers) {
        //     self.addPlacesLayers(placesLayers, map, instance, self);

        //     (async() => {
        //         while(!instance.parentElement.querySelector('button[aria-pressed][data-places-layer]')) {
        //             await new Promise(resolve => setTimeout(resolve, 50));
        //         }

        //         self.setActivePlacesLayers(instance, self);
        //     })();

        // }
        /**
        * Temporarly removing map filtering to reduce API costs
        * END
        */

        instance.dataset.progressiveEnhancement = 'on';
    }

    enhanceAll(self) {
        let i;

        if (self.mapStatus !== 'on') {
            // self.helpers.addExternalScript('https://maps.googleapis.com/maps/api/js?key=' + 'AIzaSyDDpR8C7son9oOqKTa11EQYfYpusCBUl5Y' + '&libraries=places');
            self.helpers.addExternalScript('https://maps.googleapis.com/maps/api/js?key=' + 'AIzaSyDDpR8C7son9oOqKTa11EQYfYpusCBUl5Y' + '&callback=Function.prototype');

            (async() => {
                while(!window.hasOwnProperty('google')) {
                    await new Promise(resolve => setTimeout(resolve, 50));
                }
                // Looping through each map component instance
                for (let instance of self.instances) {
                    // Initializing each map
                    instance = self.enhance(instance, self);
                }

                self.mapStatus = true;

                if(self.mapStatus) {
                    if(document.documentElement.dataset.progressiveEnhancements) {
                        document.documentElement.dataset.progressiveEnhancements += ' map';
                    } else {
                        document.documentElement.dataset.progressiveEnhancements = 'map';
                    } 
                }
            })();
        }
    }

    hidePlacesLayer(placesLayer, map, instance, self) {
        let searchParams = new URLSearchParams(window.location.search),
            places,
            markers = self.markers[placesLayer];

        for(let marker of markers) {
            if (!marker.getVisible()) {
                marker.setVisible(true);
              } else {
                marker.setVisible(false);
              }
        }

        if(searchParams.has(instance.id)) {
            places = searchParams.get(instance.id);
            
            places = places.split(',');
            
            places = places.filter(value => placesLayer !== value);
            
            places = places.join(',');
        }

        if(places.length) {
            searchParams.set(instance.id, places);
        } else {
            searchParams.delete(instance.id);
        }

        const updatedUrl =
            window.location.protocol
            + "//"
            + window.location.host
            + window.location.pathname
            + "?"
            + searchParams.toString()
            + window.location.hash;
        window.history.replaceState(null, '', updatedUrl);
    }

    setActivePlacesLayers(instance, self) {
        let places,
            searchParams = new URLSearchParams(window.location.search);

        if(!searchParams.has(instance.id)) {
            return;
        }

        places = searchParams.get(instance.id);
            
        places = places.split(',');

        for(let place of places) {
            if(!instance.parentElement.querySelector('button[data-places-layer="' + place + '"]:not([disabled])')) {
                continue;
            }

            instance.parentElement.querySelector('button[data-places-layer="' + place + '"]:not([disabled])').click();
        }

    }

    showPlacesLayer(placesLayer, map, instance, self) {
        let searchParams = new URLSearchParams(window.location.search),
            places,
            markers = self.markers[placesLayer];

        for(let marker of markers) {
            if (!marker.getVisible()) {
                marker.setVisible(true);
            } else {
                marker.setVisible(false);
            }
        }

        if(searchParams.has(instance.id)) {
            places = searchParams.get(instance.id);
            
            places = places.split(',');
            
            places = places.filter(value => placesLayer !== value);

            places.push(placesLayer);
                
            places.sort((a, b) => a.localeCompare(b));
            
            places = places.join(',');
        } else {
            places = [placesLayer];
        }

        if(places.length) {
            searchParams.set(instance.id, places);
        } else {
            searchParams.delete(instance.id);
        }

        const updatedUrl =
            window.location.protocol
            + "//"
            + window.location.host
            + window.location.pathname
            + "?"
            + searchParams.toString()
            + window.location.hash;
        window.history.replaceState(null, '', updatedUrl);
    }
}// end Class

// Singleton
export default Map;